/**
 * Nav click tracking (HELP-17910).
 * One delegated listener for every [data-nav-click] link rendered by sections/header.liquid.
 *
 * GTM (GTM-MP5JJVT) runs inside a Shopify custom pixel sandbox and cannot read this
 * page's window.dataLayer, so the same payload is also published as a Shopify custom
 * event. The pixel subscribes with analytics.subscribe('nav_click', ...) and pushes
 * event.customData into its own dataLayer.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener(
    "click",
    function (e) {
      var el = e.target.closest("[data-nav-click]");
      if (!el) return;

      var d = el.dataset;
      var href = el.getAttribute("href") || "";
      var url;
      try {
        url = new URL(href, location.href);
      } catch (err) {
        url = null;
      }

      var payload = {
        nav_location: d.navLocation || "",
        nav_section: d.navSection || "",
        nav_level: parseInt(d.navLevel, 10) || 1,
        nav_position: parseInt(d.navPosition, 10) || null,
        nav_text: (d.navText || el.textContent || "").trim().slice(0, 100),
        nav_url: (d.navUrl || href).slice(0, 100),
        nav_parent: d.navParent || "",
        nav_outbound: url ? url.hostname !== location.hostname : false,
      };

      window.dataLayer.push(Object.assign({ event: "nav_click" }, payload));

      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === "function"
      ) {
        Shopify.analytics.publish("nav_click", payload);
        
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'nav_click', Object.assign({ send_to: 'G-D1E0Q6T55P' }, payload));
        }
      }
    },
    true
  );
})();
